import React from 'react';
import { motion } from 'framer-motion';
import { Award, Shield, Clock, MapPin, Users, Wrench } from 'lucide-react';

const trustBadges = [
  { icon: Shield, title: 'Licensed & Insured', desc: 'Licensed in Calgary' },
  { icon: MapPin, title: 'Serving Calgary and Surrounding Areas', desc: 'Local experts' },
  { icon: Wrench, title: 'Residential', desc: 'Home specialists' },
  { icon: Users, title: 'Building Maintenance', desc: 'Property care' },
  { icon: Award, title: 'Light Commercial', desc: 'Small business' }
];

export const TrustBadges = () => {
  return (
    <section data-testid="trust-badges-section" className="py-12 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {trustBadges.map((badge, index) => (
            <motion.div
              key={badge.title}
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="text-center"
            >
              <div className="inline-flex p-3 bg-[#1E3A5F]/10 rounded-xl mb-3">
                <badge.icon className="w-6 h-6 text-[#1E3A5F]" strokeWidth={1.5} />
              </div>
              <h4 className="font-heading font-bold text-sm text-gray-900">{badge.title}</h4>
              <p className="text-xs text-gray-500 mt-1">{badge.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
